export default {
  loaderVisible: false, // Estado del loader (Activo/Inactivo)
};
